import { useQuery } from '@tanstack/react-query';
import { unstructuredContextService } from '../services/unstructuredContext.service';
import type { ListRecordsResponse, UnstructuredContextItem } from '../services/unstructuredContext.service';

export function useUnstructuredContextList(options?: {
  page?: number;
  pageSize?: number;
  filters?: Record<string, any>;
  enabled?: boolean;
}) {
  const {
    page = 1,
    pageSize = 50,
    filters = {},
    enabled = true,
  } = options || {};

  return useQuery<ListRecordsResponse<UnstructuredContextItem>>({
    queryKey: ['unstructuredcontexts', page, pageSize, filters],
    queryFn: () => unstructuredContextService.find({ page, pageSize, filters }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUnstructuredContextById(id: string, options?: { enabled?: boolean }) {
  const { enabled = true } = options || {};

  return useQuery<UnstructuredContextItem>({
    queryKey: ['unstructuredcontext', id],
    queryFn: () => unstructuredContextService.findById(id),
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000,
  });
}
